/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarketFormData
 */
export interface MarketFormData {
    /**
     * 
     * @type {string}
     * @memberof MarketFormData
     */
    id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MarketFormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {object}
     * @memberof MarketFormData
     */
    effectiveFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof MarketFormData
     */
    effectiveTo?: object | null;
    /**
     * 
     * @type {string}
     * @memberof MarketFormData
     */
    label?: string | null;
}

export function MarketFormDataFromJSON(json: any): MarketFormData {
    return MarketFormDataFromJSONTyped(json, false);
}

export function MarketFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarketFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'effectiveFrom': !exists(json, 'effectiveFrom') ? undefined : json['effectiveFrom'],
        'effectiveTo': !exists(json, 'effectiveTo') ? undefined : json['effectiveTo'],
        'label': !exists(json, 'label') ? undefined : json['label'],
    };
}

export function MarketFormDataToJSON(value?: MarketFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'allowEdit': value.allowEdit,
        'effectiveFrom': value.effectiveFrom,
        'effectiveTo': value.effectiveTo,
        'label': value.label,
    };
}


